(function () {
  "use strict";

  var ATC_SEL = '#btnCTA, .vs-cta-btn, button[name="add"], [data-slidecart-atc], gp-product-button button';
  var CLICKABLE = 'a, button, [role="button"], input[type="submit"], input[type="button"]';
  var HEADER_PAD = 16;
  var FALLBACK_OFFSET = 110;

  var CTAS = [
    {
      key: "drawer",
      match: /^order now for restful sleep$/i,
      label: "Get One That Fits Your Mouth",
      sub: "Two sizes. Free size exchanges."
    },
    {
      key: "jaw",
      match: /^order today for better sleep$/i,
      label: "Choose Your Size",
      sub: "Molds in minutes. Adjust the fit anytime.",
      drop: /^try it for 60[\s‐-―-]*nights?\.?$/i
    },
    {
      key: "choose",
      match: /^get quieter sleep$/i,
      label: "Get Quieter Sleep",
      sub: "Free shipping. 60-night money-back guarantee."
    },
    {
      key: "guarantee",
      match: /^give vitalsleep a try$/i,
      label: "Start My 60 Nights",
      sub: "60-night guarantee plus a 12-month replacement warranty."
    }
  ];

  function txt(el) {
    return (el.textContent || "").replace(/\s+/g, " ").trim();
  }

  function isAtc(el) {
    if (!el) return false;
    if (el.matches && el.matches(ATC_SEL)) return true;
    if (el.closest && el.closest(ATC_SEL)) return true;
    if (el.querySelector && el.querySelector(ATC_SEL)) return true;
    return false;
  }

  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function findButton(spec) {
    var nodes = document.querySelectorAll(CLICKABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute("data-vs-cta")) continue;
      if (isAtc(el)) continue;
      var t = el.value && !el.textContent ? String(el.value) : txt(el);
      if (!spec.match.test(t)) continue;
      if (!visible(el)) continue;
      return el;
    }
    return null;
  }

  function labelNode(el, current) {
    var kids = el.querySelectorAll("*");
    var best = el;
    for (var i = 0; i < kids.length; i++) {
      if (txt(kids[i]) === current && kids[i].children.length === 0) best = kids[i];
    }
    return best;
  }

  function setLabel(el, label) {
    var current = txt(el);
    if (el.tagName === "INPUT") {
      el.value = label;
      return;
    }
    var node = labelNode(el, current);
    node.textContent = label;
  }

  function stripUppercase(el) {
    el.style.setProperty("text-transform", "none", "important");
    el.style.setProperty("letter-spacing", "normal", "important");
    var kids = el.querySelectorAll("*");
    for (var i = 0; i < kids.length; i++) {
      kids[i].style.setProperty("text-transform", "none", "important");
      kids[i].style.setProperty("letter-spacing", "normal", "important");
    }
  }

  function dropLine(el, re) {
    var scope = el;
    for (var up = 0; up < 4 && scope.parentElement; up++) {
      scope = scope.parentElement;
      var cands = scope.querySelectorAll("p, div, span, small, li, em, i");
      for (var i = 0; i < cands.length; i++) {
        var c = cands[i];
        if (c === el || c.contains(el)) continue;
        if (c.querySelector(CLICKABLE)) continue;
        if (!re.test(txt(c))) continue;
        if (c.parentNode) c.parentNode.removeChild(c);
        return true;
      }
    }
    return false;
  }

  function addSubline(el, text) {
    if (el.nextElementSibling && el.nextElementSibling.classList.contains("vs-ctaline")) return;
    var p = document.createElement("p");
    p.className = "vs-ctaline";
    p.setAttribute("data-vs-ctaline", "1");
    p.textContent = text;
    if (el.parentNode) el.parentNode.insertBefore(p, el.nextSibling);
  }

  function headerOffset() {
    var max = 0;
    var nodes = document.querySelectorAll("header, [class*='header'], [id*='header']");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!visible(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== "fixed" && cs.position !== "sticky") continue;
      var r = el.getBoundingClientRect();
      if (r.top > 60) continue;
      if (r.height > max && r.height < 260) max = r.height;
    }
    return (max || FALLBACK_OFFSET) + HEADER_PAD;
  }

  function buyBox() {
    var atc = document.querySelector("#btnCTA");
    if (!atc || !visible(atc)) {
      var all = document.querySelectorAll("button, a, input[type=submit]");
      for (var i = 0; i < all.length; i++) {
        var t = (all[i].value || all[i].textContent || "").trim();
        if (/add\s+.*\bto\s+cart\b/i.test(t) && visible(all[i])) {
          atc = all[i];
          break;
        }
      }
    }
    if (!atc) return document.querySelector("h1");

    var node = atc;
    for (var up = 0; up < 6 && node.parentElement; up++) {
      node = node.parentElement;
      if (node.querySelector('select, input[type="radio"], [class*="variant" i], [class*="size" i]')) return node;
    }
    return atc;
  }

  function scrollToBuyBox() {
    var box = buyBox();
    if (!box) return;
    var top = box.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    if (top < 0) top = 0;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    try {
      window.scrollTo({ top: top, behavior: reduce ? "auto" : "smooth" });
    } catch (err) {
      window.scrollTo(0, top);
    }
  }

  function wire(el) {
    el.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToBuyBox();
      },
      true
    );
  }

  function apply() {
    var done = 0;
    for (var i = 0; i < CTAS.length; i++) {
      var spec = CTAS[i];
      var el = findButton(spec);
      if (!el) continue;

      el.setAttribute("data-vs-cta", spec.key);
      if (spec.drop) dropLine(el, spec.drop);
      setLabel(el, spec.label);
      stripUppercase(el);
      addSubline(el, spec.sub);
      wire(el);
      done++;
    }
    return done;
  }


  /* 16-Sep-2026 speed fix: the page-wide watcher used to run forever. Any change
     anywhere on the page (the 1-second shipping countdown, carousels, the cart)
     re-ran the text search below. Now it watches for WATCH_MS after load and
     stops as soon as the job is done. A click or a resize re-checks for a few
     seconds, which covers popups and tabs that build their content late. */
  var WATCH_MS = 15000;
  var REARM_MS = 3000;
  function leash(check) {
    var obs = null, stopT = null, queued = false;
    function stop() {
      if (obs) { obs.disconnect(); obs = null; }
      if (stopT) { clearTimeout(stopT); stopT = null; }
    }
    function run() {
      queued = false;
      if (check()) stop();
    }
    function arm(ms) {
      if (!window.MutationObserver) return;
      if (!obs) {
        obs = new MutationObserver(function () {
          if (queued) return;
          queued = true;
          setTimeout(run, 250);
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
      }
      if (stopT) clearTimeout(stopT);
      stopT = setTimeout(stop, ms);
    }
    var pokeT = null;
    function poke() {
      if (pokeT) return;
      pokeT = setTimeout(function () {
        pokeT = null;
        if (!check()) arm(REARM_MS);
      }, 350);
    }
    if (!check()) arm(WATCH_MS);
    document.addEventListener("click", poke, true);
    window.addEventListener("resize", poke, { passive: true });
  }

  function start() {
    leash(function () {
      if (document.querySelectorAll("[data-vs-cta]").length >= CTAS.length) return true;
      apply();
      return document.querySelectorAll("[data-vs-cta]").length >= CTAS.length;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
